import { render, staticRenderFns } from "./MeanMedianMode.vue?vue&type=template&id=60ddaa04&scoped=true"
import script from "./MeanMedianMode.vue?vue&type=script&lang=js"
export * from "./MeanMedianMode.vue?vue&type=script&lang=js"
import style0 from "./MeanMedianMode.vue?vue&type=style&index=0&id=60ddaa04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ddaa04",
  null
  
)

export default component.exports